/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_CutInputs */

const en_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut`)
};

const fr_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper`)
};

const de_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schneiden`)
};

const it_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglio`)
};

const ru_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резать`)
};

const es_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar`)
};

const zh_cn2_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切`)
};

const ja_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カット`)
};

const hi_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काटना`)
};

const pt_pt2_context_menu_cut = /** @type {(inputs: Context_Menu_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corte`)
};

/**
* | output |
* | --- |
* | "Cut" |
*
* @param {Context_Menu_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_cut = /** @type {((inputs?: Context_Menu_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_cut(inputs)
	if (locale === "de") return de_context_menu_cut(inputs)
	if (locale === "it") return it_context_menu_cut(inputs)
	if (locale === "ru") return ru_context_menu_cut(inputs)
	if (locale === "es") return es_context_menu_cut(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_cut(inputs)
	if (locale === "ja") return ja_context_menu_cut(inputs)
	if (locale === "hi") return hi_context_menu_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_cut(inputs)
	return en_context_menu_cut(inputs)
});